import type { ITag, ITagData } from "./tag.types";
import { AbstractModel } from "../base";

export class Tag extends AbstractModel implements ITag {
    readonly name: string;
    readonly id?: number;
    constructor(data: ITagData) {
        super();

        // Validate data
        const requiredFields: (keyof ITagData)[] = ['name'];
        this.validate(data, requiredFields);

        // Initialize object assuming data valid
        this.name = data.name!;

        // Set id if provided
        if (data.id) {
            this.id = data.id;
        }
    }
}